const ImageLoader = {

    load(image, src, type) {
        if (image.length && src.length) {
            ImageLoader
                .preload(src)
                .then(() => ImageLoader.insert(image, src, type))
                .catch((e) => console.log('Error on loading image. Image path: ' + src));
        }
    },

    preload(src) {
        return new Promise((success, error) => {
            const image = new Image();
            image.onload = success;
            image.onerror = error;
            image.src = src;
        });
    },
    insert(element, src, type) {
        // todo: maybe some other types?
        switch (type) {
            case "background":
                ImageLoader.setBackground(src, element);
                break;
            default:
                ImageLoader.setSrc(src, element);
                break;
        }
    },
    setBackground(src, element) {
        element.css({
            'background-image': 'url("' + src + '")'
        });
    },
    setSrc(src, element) {
        element.attr('src', src);
    },
    preloadDefaultImages() {
        $('[data-image-preload]').each(function () {
            const element = $(this),
                src = element.data('image-preload'),
                type = element.data('image-type');

            element.removeAttr('data-image-preload')
                .removeAttr('data-iamge-type');

            if (element.length && src.length) {
                ImageLoader
                    .preload(src)
                    .then(() => ImageLoader.insert(src, element, type))
                    .catch((e) => console.log('Error on loading image. Image path: ' + src));
            }
        });
    }

};


export default ImageLoader;